'use client';

import { createContext, useContext, type ReactNode } from 'react';
import type { AgentExecutionDto } from '@terra/shared-contracts-agent-execution';
import type { ExecutionsSelectAllState } from '../executions-table/executions-list.model';

export type AgentExecutionsTableContextValue = {
  selectAllState: ExecutionsSelectAllState;
  hasRows: boolean;
  isSelectionLocked: boolean;
  isExecutionSelected: (execution: AgentExecutionDto) => boolean;
  onToggleExecutionSelected: ({
    execution,
    selected,
  }: {
    execution: AgentExecutionDto;
    selected: boolean;
  }) => void;
  onSelectAll: (selected: boolean) => void;
  abortingIds: ReadonlySet<string>;
  onAbortExecution: (execution: AgentExecutionDto) => void;
  onDeleteExecution: (execution: AgentExecutionDto) => void;
};

const AgentExecutionsTableContext =
  createContext<AgentExecutionsTableContextValue | null>(null);

export function AgentExecutionsTableContextProvider({
  value,
  children,
}: {
  value: AgentExecutionsTableContextValue;
  children: ReactNode;
}) {
  return (
    <AgentExecutionsTableContext.Provider value={value}>
      {children}
    </AgentExecutionsTableContext.Provider>
  );
}

export function useAgentExecutionsTableContext() {
  const value = useContext(AgentExecutionsTableContext);

  if (!value) {
    throw new Error(
      'useAgentExecutionsTableContext must be used inside AgentExecutionsTableContextProvider',
    );
  }

  return value;
}
